import type { Pagination } from '@aigc/types';
import { useNavigate } from '@tanstack/react-router';
import { Route } from '../../routes/_creator-center/video/history';
import { VideoHistory } from '../statistics/components/video-history';

export function VideoHistoryPage() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  const handlePaginationChange = (pagination: Pagination) => {
    navigate({
      replace: true,
      search: {
        page: pagination.page ?? 1,
        pageSize: pagination.size ?? 10,
      },
    });
  };

  return (
    <VideoHistory
      defaultPagination={{ page: search?.page, size: search?.pageSize }}
      onPaginationChange={handlePaginationChange}
    />
  );
}
